import React from 'react';
import { useIntl } from 'react-intl';

import { FieldGroup } from '@xsolla/ui-core';

import { FieldBlock, FieldInput } from '../../ui';
import { FieldWrapper } from '../style';
import { FieldsProps, ValidationError } from './types';
import { maxFieldLength } from './validator';

export const EmailFields = ({ errors, projectName }: FieldsProps): JSX.Element => {
  const intl = useIntl();

  const getError = (field: keyof ValidationError): string => {
    if (errors && errors[field]) {
      return intl.formatMessage(
        { id: errors[field] as string },
        {
          number: maxFieldLength
        }
      );
    }

    return '';
  };

  return (
    <>
      <FieldWrapper>
        <FieldBlock
          title={intl.formatMessage({ id: 'custom-providers.settings.email.settings.label' })}
          description={intl.formatMessage({
            id: 'custom-providers.settings.email.settings.description'
          })}>
          <FieldGroup
            label={intl.formatMessage({ id: 'custom-providers.settings.email.from_name.label' })}
            size="md">
            <FieldInput
              name="from_email_name"
              subLabel={intl.formatMessage({
                id: 'custom-providers.settings.email.from_name.footer'
              })}
              placeholder={projectName}
              errorMessage={getError('from_email_name')}
            />
          </FieldGroup>

          <FieldGroup
            label={intl.formatMessage({ id: 'custom-providers.settings.email.from_email.label' })}
            size="md">
            <FieldInput
              placeholder={intl.formatMessage({
                id: 'custom-providers.settings.email.from_email.placeholder'
              })}
              name="custom_email"
              subLabel={intl.formatMessage({
                id: 'custom-providers.settings.email.from_email.footer'
              })}
              errorMessage={getError('custom_email')}
            />
          </FieldGroup>
        </FieldBlock>
      </FieldWrapper>
    </>
  );
};
